// Central content + curated imagery for the AquaFionix site.
// Copy is written strictly from the brief — no invented stats, certifications or claims.

export const LOGO = "https://customer-assets-v7afamib.emergentagent.net/job_cage-culture-preview/artifacts/clerswu3_file_0000000007848208a3fb4e551f143f65.png";

export const IMAGES = {
  makhanaPond: "https://images.pexels.com/photos/9663532/pexels-photo-9663532.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1600",
  integratedBg: "https://static.prod-images.emergentagent.com/jobs/b61a671c-7d46-47f5-9000-3a5faea462f0/images/7cd14fc064aa59d3dc65ce480579a7bf41106054107f2c6d04281e393f338fab.jpeg",
  aboutOps: "https://images.pexels.com/photos/7509423/pexels-photo-7509423.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000",
  ras: "https://images.unsplash.com/photo-1644389355109-15b26f71c36b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  vannamei: "https://images.unsplash.com/photo-1657856282105-952b3c683d15?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  mudCrab: "https://images.unsplash.com/photo-1509415173911-37ff7a1aa29c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  technology: "https://images.pexels.com/photos/14024725/pexels-photo-14024725.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000",
  shrimpDetail: "https://images.pexels.com/photos/32230041/pexels-photo-32230041.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1000",
  sustainability: "https://images.unsplash.com/photo-1608953029601-7a6e5e7fd548?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  partnerships: "https://images.unsplash.com/photo-1615141982883-c7ad0e69fd62?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  finalCta: "https://images.unsplash.com/photo-1621519997950-158b631341b6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

export const NAV_ITEMS = [
  { label: "Home", type: "route", to: "/", testId: "nav-home-link" },
  { label: "About Us", type: "section", href: "about", testId: "nav-about-link" },
  { label: "Aquaculture", type: "section", href: "aquaculture", testId: "nav-aquaculture-link" },
  { label: "Makhana", type: "route", to: "/makhana-export", testId: "nav-makhana-link" },
  { label: "Exports", type: "route", to: "/exports", testId: "nav-exports-link" },
  { label: "Contact", type: "section", href: "inquiry", testId: "nav-contact-link" },
];

export const EXPERIENCE = [
  "Shrimp Farm Operations",
  "Crab Farming",
  "RAS Systems",
  "Nursery & Stocking",
  "Feed Management",
  "Water Quality Management",
  "Harvesting",
  "Market Linkage",
];

export const SOLUTIONS = [
  { title: "RAS Shrimp Farming", desc: "Recirculating Aquaculture Systems for controlled, high-tech shrimp production with continuous water treatment and reuse.", image: IMAGES.ras },
  { title: "RAS Crab Farming", desc: "RAS-assisted crab culture designed around biosecurity, water quality and carefully monitored growth.", image: IMAGES.mudCrab },
  { title: "Zero-Waste Operations", desc: "Water recirculation, waste capture and by-product utilization built into farm design — planned around a zero-waste approach.", image: IMAGES.sustainability },
  { title: "Makhana Pond", desc: "Pond-based makhana (fox nut) cultivation integrated within our aquaculture model — the origin of our priority export product.", image: IMAGES.makhanaPond },
];

export const SPECIES = [
  { name: "Vannamei Shrimp", note: "Widely traded white-leg shrimp — planned for RAS-assisted, high-tech culture.", image: IMAGES.vannamei },
  { name: "Mud Crab", note: "High-value brackish-water species — planned for RAS-assisted crab farming.", image: IMAGES.mudCrab },
];

export const SEED_TO_HARVEST = [
  "Planning", "Quality Seed", "Nursery", "Grow-Out", "Feed & Water Management", "Harvest", "Market",
];

export const TECHNOLOGY = [
  "Water Quality Monitoring",
  "Feed Management",
  "Biomass Monitoring",
  "Farm Records",
  "Growth Monitoring",
  "Production Planning",
  "Modern Aquaculture Systems",
];

export const INTEGRATED_FLOW = [
  "Shrimp Farming", "Crab Farming", "Makhana Pond", "Processing", "By-product Utilization", "Market Linkage", "Value Creation",
];

export const SHRIMP_STEPS = [
  "System Preparation", "Quality Seed", "Stocking", "Aeration", "Water Quality", "Feeding", "Biosecurity", "Monitoring", "Harvesting",
];

export const FARM_TO_MARKET = [
  "Farm", "Harvest", "Quality Handling", "Processing", "Cold Chain", "Buyer", "Market",
];

export const SUSTAINABILITY = [
  { title: "Efficient Water Utilization", desc: "Recirculating systems that treat and reuse water across farming operations." },
  { title: "Responsible Aquaculture", desc: "Farming practices focused on health, quality and stewardship." },
  { title: "Resource Optimization", desc: "Getting more from feed, water and infrastructure inputs." },
  { title: "Zero-Waste Focus", desc: "Designing operations to eliminate waste across the production and handling cycle." },
  { title: "By-product Utilization", desc: "Putting suitable by-products to productive use." },
  { title: "Integrated Farming", desc: "Connecting shrimp, crab and makhana activities so they support one another." },
];

export const WHY = [
  { title: "Practical Experience", desc: "Hands-on experience across farm operations, stocking, feeding, harvesting and marketing." },
  { title: "Scientific Management", desc: "Structured farm management guided by monitoring and records." },
  { title: "High-Tech RAS Focus", desc: "RAS-assisted shrimp and crab farming designed around zero-waste operation." },
  { title: "Integrated Thinking", desc: "Connecting farming, processing and market linkage end to end." },
  { title: "Market Orientation", desc: "Production planned around real buyer and market requirements." },
  { title: "Sustainable Approach", desc: "Efficient use of water and resources with responsible practices." },
];

export const PARTNERS = [
  "Seafood Processors", "Shrimp Buyers", "Crab Buyers", "Makhana Importers", "Wholesalers", "Distributors",
  "Institutional Buyers", "Aquaculture Suppliers", "Farmers", "Strategic Partners",
];

export const CONTACT = {
  company: "AquaFionix Integrated Aquaculture Pvt. Ltd.",
  office: "Innov8 Q Parc, Plot No. G/1, Floor No. 13th, B-No Q2 GHA, Ghansoli, Rabale, Thane – 400701, Maharashtra, India.",
  farm: "Ransai Dam, Dighode, Navi Mumbai, Maharashtra.",
  website: "aquafionix.com",
  websites: ["aquafionix.in", "www.aquafionix.com"],
  whatsapp: "7738643555",
  whatsappIntl: "917738643555",
  ceoPhone: "8855820646",
  phones: ["7738643555", "8855820646"],
  emails: ["contact@aquafionix.com", "aquafionix7@gmail.com"],
  exportEmail: "contact@aquafionix.com",
  cin: "U47219MR2026PTC479069",
  pan: "ABGCA2948B",
  tan: "MUMA88998A",
};

export const MARQUEE = [
  "RAS Shrimp Farming", "Mud Crab", "Zero-Waste Aquaculture", "Vannamei Shrimp",
  "Makhana / Fox Nuts", "Makhana Pond", "Water Recirculation", "Market Linkage",
  "Export-Oriented Supply", "Sustainable Aquaculture",
];

// ---------------- Export / Makhana positioning ----------------
export const EXP = {
  makhanaBowl: "https://customer-assets-v7afamib.emergentagent.net/job_cage-culture-preview/artifacts/qsup5elz_IMG_20260921_195134.jpg",
  makhanaJars: "https://customer-assets-v7afamib.emergentagent.net/job_cage-culture-preview/artifacts/4qtgemzq_IMG_20260921_195054.jpg",
  makhanaProcessing: "https://customer-assets-v7afamib.emergentagent.net/job_cage-culture-preview/artifacts/f67jbzh4_IMG_20260921_195354.webp",
  makhanaMacro: "https://customer-assets-v7afamib.emergentagent.net/job_cage-culture-preview/artifacts/0zzig27b_IMG_20260921_195939.jpg",
  exportPort: "https://images.unsplash.com/photo-1605732562742-3023a888e56e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  packaging: "https://static.prod-images.emergentagent.com/jobs/b61a671c-7d46-47f5-9000-3a5faea462f0/images/ad2bdd11e3bcb92b246b78e39d4cabf622421ab975b7215e0c2aa18f4a4c4194.jpeg",
  makhanaPouch: "https://static.prod-images.emergentagent.com/jobs/b61a671c-7d46-47f5-9000-3a5faea462f0/images/ad2bdd11e3bcb92b246b78e39d4cabf622421ab975b7215e0c2aa18f4a4c4194.jpeg",
  uae: "https://images.unsplash.com/photo-1512453979798-5ea266f8880c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
  makhanaAI: "https://customer-assets-v7afamib.emergentagent.net/job_cage-culture-preview/artifacts/4qtgemzq_IMG_20260921_195054.jpg",
};

export const POSITIONING_TAGS = ["Aquaculture", "Food Products", "Export"];

export const PRODUCT_OPTIONS = [
  "Makhana / Fox Nuts",
  "Aquaculture Products",
  "Shrimp – Future Inquiry",
  "Other",
];

export const MAKHANA_SUPPLY = [
  "Indian Makhana / Fox Nuts",
  "Multiple grades and sizes, subject to availability",
  "Bulk supply",
  "Export-oriented packaging",
  "Custom packaging / private label, subject to order requirements",
  "Buyer-specific specifications",
  "Commercial quantities",
  "International buyer inquiries",
];

export const MAKHANA_GRADES = ["4 Suta", "5 Suta", "6 Suta", "6+ Suta", "Handpicked", "Machine Graded"];

export const PACKAGING_OPTIONS = [
  { title: "Pouch Packed Fox Nuts", desc: "Retail-ready stand-up pouches of premium makhana (fox nuts)." },
  { title: "Bulk / Commercial Packs", desc: "Larger packs for commercial, wholesale and food-service buyers." },
  { title: "Private Label", desc: "Custom branding & packaging, subject to order requirements." },
  { title: "Buyer-Specific", desc: "Packaging tailored to buyer and destination-market needs." },
];

export const MARKETS = ["UAE", "Middle East", "Europe", "Other International Markets"];

export const EXPORT_WORKFLOW = [
  "Buyer Inquiry",
  "Product Specification",
  "Quotation",
  "Sample / Quality Confirmation",
  "Packaging",
  "Documentation",
  "Shipment",
];

export const WHY_AQUAFIONIX = [
  { title: "Indian Company", desc: "An India-based aquaculture and food-products company." },
  { title: "Industry Experience", desc: "Practical experience across the aquaculture value chain." },
  { title: "Direct Communication", desc: "Work directly with our team — clear, buyer-first communication." },
  { title: "Sourcing & Supply", desc: "Product sourcing and supply coordination for commercial orders." },
  { title: "Export-Oriented Packaging", desc: "Packaging prepared with export and destination markets in mind." },
  { title: "Documentation Support", desc: "Destination-market documentation arranged as applicable." },
];

export const MAKHANA_FAQ = [
  { q: "Is AquaFionix a Makhana exporter or retailer?", a: "AquaFionix is developing export-oriented Makhana supply for international B2B buyers — importers, distributors, wholesalers, food companies and private-label buyers — not a retail-only seller." },
  { q: "What grades and sizes are available?", a: "Indian Makhana is available in multiple grades and sizes (commonly graded by Suta count and pop size in mm), subject to availability. Exact specifications are confirmed against each order." },
  { q: "Can you do private label / custom packaging?", a: "Yes — custom packaging and private label are available, subject to order requirements and destination-market needs." },
  { q: "What is the minimum order quantity and price?", a: "MOQ, specifications and pricing are shared on a per-inquiry basis depending on grade, packaging and destination. Please submit an inquiry for current commercial information." },
  { q: "Which certifications do you hold?", a: "Export documentation and product certifications are arranged according to the requirements of the destination country, product category and applicable regulations. Specific documentation is provided as applicable to the shipment." },
  { q: "Do you export shrimp?", a: "Shrimp and other aquaculture products are a planned future export vertical and are not currently offered for export. They will be developed subject to production, quality standards and documentation." },
];

export const COMPLIANCE_NOTE = "Export documentation and product certifications will be arranged according to the requirements of the destination country, product category and applicable regulations. Specific documentation and certifications will be provided as applicable to the destination market and shipment.";
